import { Component } from "@angular/core";

import { BaseComponent, UserService, environment } from "@mypxplat/xplat/core";
import { NgxSpinnerService } from "ngx-spinner";
import { take } from "rxjs/operators";

@Component({
  selector: "myp-beta-loader",
  templateUrl: "beta-loader.component.html",
})
export class BetaLoaderComponent extends BaseComponent {
  public shouldShow = true;

  constructor(public userService: UserService, private spinner: NgxSpinnerService) {
    super(userService);
  }

  ngOnInit() {
    if (!environment.features.sphere_beta) {
      this.shouldShow = false;
    } else {
      this.spinner.show();
    }
  }
}
